// frontend/src/pages/Assignments.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// import MainLayout from '../../layouts/MainLayout';
import './styles/AssignmentTopics.css';
import AssignmentTopics from './AssignmentTopics';
import MyAssignmentList from './MyAssignmentList';

const Assignments = () => {
  const [showAssignments, setShowAssignments] = useState(false);

  const handleShowAssignments = () => {
    setShowAssignments(!showAssignments);
  };

  const topics = [
    {
      title: 'About',
      description: (
        <div className="ml-4 mr-4 mt-4">
           <p>
            The Learning module is your gateway to a wealth of knowledge. Access various resources, whitepapers,
            videos, and courses designed to enhance critical thinking skills using the Think5Whys framework.
            Elevate your understanding and application of this powerful methodology.
           </p><br/>
            <p>Welcome to the <strong>Think5Whys DIY assignment</strong>, a unique opportunity for individuals to dive deep into the world of Root Cause Analysis (RCA) and unleash their problem-solving potential. Engaging in this assignment offers a myriad of benefits, including the chance to hone critical thinking skills, foster a proactive mindset, and cultivate a habit of continuous improvement.</p><br/>
            
            <p>At Think5Whys, we understand the transformative power of RCA in identifying the underlying causes of issues and making informed decisions. By embarking on this DIY assignment, participants not only enhance their RCA proficiency but also gain valuable insights into personal and professional challenges.</p><br/>
            
            <p>Our DIY assignment serves as more than just a learning exercise; it's an engagement tool designed to inspire learners to actively participate in RCA for their own growth and development. Whether you're seeking to improve study habits, optimize work processes, or address personal challenges, the Think5Whys DIY assignment empowers you to take charge of your journey towards success.</p><br/>
            
        </div>
      ),
    },
    {
      title: 'Process',
      description: (
        <div>
          <p>
            <strong style={{ color: 'white' }}>1. Read The RCA Book:</strong>
          </p>

          <p>
            <strong style={{ color: 'white' }}>2. Select the Topic provided here:</strong>
          </p>

          <p>
            <strong style={{ color: 'white' }}>3. DIY on the Assignment Worksheet Form</strong>
          </p>

          <p>
            <strong style={{ color: 'white' }}>4. Fill Your Sheet Online</strong>
                In the Navbar Think5Whys<br/>
                A Form For RCA Will Appear<br/>
                Fill the Form and Submit / Save <br/>
                More information will come ....
          </p>
        </div>
      ),
    },
    {
      title: 'Common Problem Topics',
      description: (
        <div>
          <div>
            <p><strong>1. Overcoming Procrastination:</strong>
                Uncover the root causes behind procrastination and create an actionable plan for improvement.
            </p><br />
            <p><strong>2. Decision-Making Dilemmas: </strong>
                 Analyze a specific decision you struggled with, identify the underlying challenges, and develop insights for future choices.
            </p><br />   
            <p><strong>3. Work-Life Balance:</strong>
                 Investigate the factors affecting your work-life balance and propose strategies to achieve a more harmonious lifestyle.
            </p><br />   
            <p><strong>4. Goal Setting and Achievement:</strong>
                Examine your past goals, understand any impediments faced, and refine your approach to goal setting for future success.
            </p><br />
            <p><strong>5. Communication Challenges:</strong>
                Explore instances where communication breakdowns occurred, delve into the reasons, and propose ways to enhance communication effectiveness.
            </p><br />   
            <p><strong>6. Deteriorating Academic Performance:</strong>
                Examine the factors contributing to your underperformance in a particular exam or contest compared to your expectations. Uncover the root causes, and strategize ways to prevent its recurrence in the future.
            </p><br />               
          </div>
        </div>
      ),
    },
    {
      title: 'Common Goal Topics',
      description: (
        <div>
            <div>
                <p>
                    <strong>1. Entrepreneurial Dreams:</strong><br/>
                    Express your desire to start a business including setting up own factory. Use Think5Whys DIY assignment workbook to uncover the motivations and potential obstacles behind your entrepreneurial goal, helping you refine your strategy.
                </p><br /> 
                <p>
                    <strong>2. Gaming Enthusiast's Path:</strong><br/>
                    Share your ambition to become a professional gamer. Use Think5Whys DIY assignment workbook to explore the underlying factors influencing your gaming aspirations, guiding you to make informed decisions for skill development.
                </p><br /> 
                <p>
                    <strong>3. Professional Aspiration:</strong><br/>
                    Communicate your goal to become a professional like engineer, doctor, lawyer, financial advisor, coach, sportsperson etc. Use Think5Whys DIY assignment workbook to delve into the reasons driving your choice and potential challenges, aiding you in setting realistic milestones for your professional career.
                </p><br /> 
                <p>
                    <strong>4. Blogger or YouTuber Aspiration:</strong><br/>
                    Communicate your goal to become a YouTuber or like. Use Think5Whys DIY assignment workbook to delve into the reasons driving your choice and potential challenges, aiding you in setting realistic milestones for become a blogger or YouTube career.
                </p><br /> 
                <p>
                    <strong>5. Becoming a Social Worker:</strong><br/>
                    Communicate your goal to become a social worker or reformist. Use Think5Whys DIY assignment workbook to delve into the reasons driving your choice and potential challenges, aiding you in setting realistic milestones for become a social worker or like.
                </p>
            </div>
        </div>
      )
    },
  ];

  const [expandedTopic, setExpandedTopic] = useState(null);

  const handleTopicClick = (index) => {
    setExpandedTopic(expandedTopic === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-black py-2">
      <div className='border-b border-blue-400 mb-2'>
        <h2 className="text-lg lg:text-xl font-extrabold text-center text-yellow-200 mb-2 p-2">
          📖 Think5Whys DIY Assignments
        </h2>
      </div>
      <div className="min-h-screen py-2 bg-black text-white">      
        <div className="px-2">
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2 mb-4">
            {topics.map((topic, index) => (
              <div
                key={index}
                onClick={() => handleTopicClick(index)}
                className={`text-center p-3 rounded-lg cursor-pointer transition-all duration-300
                  ${expandedTopic === index ? 'bg-blue-700' : 'bg-blue-600 hover:bg-blue-700'}`
                }
              >
                <span className="text-sm lg:text-base text-yellow-200 font-medium">{topic.title}</span>
              </div>
            ))}
          </div>

          {expandedTopic !== null && topics[expandedTopic] && (
            <div className="bg-black border-gray-300 text-white p-4 rounded-lg shadow-md">
              <h3 className="text-yellow-300 text-lg font-semibold mb-2">{topics[expandedTopic].title}</h3>
              <p className="text-sm lg:text-m text-gray-300">{topics[expandedTopic].description}</p>
            </div>
          )}
        </div>

        <AssignmentTopics/>
        <div className="m-auto my-2 p-2 w-full">
          <button className="text-white bg-blue-800 text-sm lg:text-m mt-2 ml-4 mr-4 w-48 lg:w-64" onClick={handleShowAssignments}>
            {showAssignments ? 'Hide My Assignments' : 'Show My Assignments'}
          </button>
        </div>
        {showAssignments && <MyAssignmentList />}
      </div>
      <footer className="bg-black border-t border-blue-400 text-gray-400 py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>  
    </div>
  );
};

export default Assignments;





